const init = () => {
  // No-op: Mixpanel is disabled
}

const track = () => {
  // No-op: Mixpanel is disabled
}

export default {
  init,
  track,
}
